module.exports = __webpack_public_path__ + "img/history-black-24-dp.8c01ae64.svg";